import { createScopedDescriptor } from 'quartz/globalState/api';
export const TRACKING_CONTEXT = createScopedDescriptor('trackingContext', 'EXECUTION_CONTEXT');